import axios from 'axios'

export function getPendingOnboardingSurvey() {
  return axios.get('onboarding-survey/pending')
}

export function submitOnboardingSurvey(payload) {
  return axios.post('onboarding-survey/submit', payload)
}
